export default function CalendarIcon({ color = '#38383A', opacity = '0.6' }) {
  return (
    <>
      <path
        d='M6.66797 1.66797V4.16797'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.332 1.66797V4.16797'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.91797 7.57422H17.0846'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5 7.08464V14.168C17.5 16.668 16.25 18.3346 13.3333 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V7.08464C2.5 4.58464 3.75 2.91797 6.66667 2.91797H13.3333C16.25 2.91797 17.5 4.58464 17.5 7.08464Z'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.0801 12.6667H13.0875'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.96631'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.99803 12.6667H10.0055'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.96631'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.91209 12.6667H6.91957'
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth='1.96631'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
